import React from 'react';

export const TermsOfService: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">Terms of Service</h1>
    <p className="text-gray-500 dark:text-gray-400 mb-8">Last updated: March 2026</p>

    <div className="prose dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">1. Acceptance of Terms</h2>
        <p>By accessing or using the RaffleBowl platform ("Service"), you agree to be bound by these Terms of Service. If you do not agree, you may not use the Service.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">2. Eligibility</h2>
        <p>You must be at least 18 years old and legally permitted to participate in raffles in your jurisdiction. By using the Service, you represent that you meet these requirements.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">3. Account Registration</h2>
        <p>You must create an account to purchase tickets or participate in raffles. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">4. Raffle Participation</h2>
        <p>Ticket purchases are final and non-refundable. Each ticket grants one entry into the applicable draw. Winners are selected using a cryptographically secure random process. Prize amounts depend on total ticket sales for the draw period, minus applicable fees.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">5. Fees and Payments</h2>
        <p>A platform fee is deducted from each draw's prize pool. Withdrawal fees may apply depending on the payout method. All fees are disclosed before you confirm a transaction.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">6. Wallet and Withdrawals</h2>
        <p>Winnings are credited to your RaffleBowl wallet. You may request withdrawals at any time, subject to minimum withdrawal amounts and verification requirements. Processing times vary by method.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">7. Prohibited Conduct</h2>
        <p>You may not use the Service for any unlawful purpose, attempt to manipulate draws, create multiple accounts, or engage in fraudulent activity. Violation may result in account suspension or termination.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">8. Limitation of Liability</h2>
        <p>RaffleBowl is provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">9. Modifications</h2>
        <p>We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">10. Contact</h2>
        <p>If you have questions about these Terms, please contact us through the Contact Us page.</p>
      </section>
    </div>
  </div>
);
